import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from '@/router/index'
import './permission' // permission control
import '@/assets/static/css/index.css'

import * as filters from './filters' // global filters

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

import Element from 'element-ui'
import './styles/element-variables.scss'

import permissionDirective from "@/directive/permission/permission";

Vue.directive('permission', permissionDirective)

// 防止连击
Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener(
        'click',
        (e) => {
          console.log('el-click', el.disabled)
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 3000)
          } else {
            e.preventDefault()
            e.stopPropagation()
          }
        },
        true
    )
  }
})

import service from './axios/service'
Vue.use(service)
Vue.prototype.$store = store

Vue.use(Element)

Vue.config.productionTip = false

// 事件总线用于组件间传值
Vue.prototype.$EventBus = new Vue()

Vue.prototype.$store = store

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
